var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-vue',{class:_vm.agGrid.agGridClass,style:(_vm.agGrid.agGridStyle),attrs:{"gridOptions":_vm.agGrid.gridOptions,"columnDefs":_vm.agGrid.columnDefs,"rowData":_vm.rowData,"frameworkComponents":_vm.agGrid.frameworkComponents,"pagination":_vm.agGrid.pagination,"enableRtl":(_vm.agGrid.enableRtl)? true : false,"defaultColDef":{
        sortable: true,
        resizable: true,
        filter: true
    },"rowSelection":"multiple"},on:{"grid-ready":_vm.onReady}})}
var staticRenderFns = []

export { render, staticRenderFns }